var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aa151b",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf00",
    d: "M.7 10H54v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m11.3 17.8-.2-.1v-.1l-.1-.2.1-.1h.2l.1-.1h1.2l.1.2v.2l-.1.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.3 17.8-.2-.1v-.1l-.1-.2.1-.1h.2l.1-.1h1.2l.1.2v.2l-.1.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.8 17.3V17q.2 0 .2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 17.3V17q.2 0 .2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.8 17.3V17l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 17.3V17l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.8 17h.2l-.1.1m.1-.1h-.2v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17h-.2v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M12 17h-.2v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17h-.2v-.1h.1zm0 0-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.9 17.8h-.4v-.4l-.3-.2q.2 0 .5.3h.3q.3-.4.5-.3l-.2.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.8h-.4v-.4l-.3-.2q.2 0 .5.3h.3q.3-.4.5-.3l-.2.3v.2zm-.7-.6.4.3m1-.3-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.3 18v-.1q.6-.3 1.2 0h-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 18v-.1q.6-.3 1.2 0h-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.9 18.1h.5V18h-1.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 18.1h.5V18h-1.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m12.5 17.8-.1-.1h-1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 17.8-.1-.1h-1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.9 17.6h.4v.1h.3v.1h-.2l-.1-.1H12a.1.1 0 0 1-.2 0 .1.1 0 0 1-.2 0h-.3l-.1.1h-.1v-.1h.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.6h.4v.1h.3v.1h-.2l-.1-.1H12a.1.1 0 0 1-.2 0 .1.1 0 0 1-.2 0h-.3l-.1.1h-.1v-.1h.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.9 17.8h-.6zh.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.8h-.6zh.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M11.5 18v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M11.9 18h-.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 18h-.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.9 17.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.7 17.5h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 17.5h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.4 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.3 17.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 17.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M12.3 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M12.5 17.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M12.5 17.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m12.7 17.7.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7 17.7.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11 18.6h1.8V18H11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11 18.6h1.8V18H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.2 18.9h1.4v-.2h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M11.2 18.9h1.4v-.2h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.2 18.9h1.4v.1h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11.2 18.9h1.4v.1h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.2 18.6h1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11.2 18.6h1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "m13.1 26.5-.3-.1h-2.2v.3l.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m13.1 26.5-.3-.1h-2.2v.3l.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m13.1 26.7-.3-.1h-2.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m13.1 26.7-.3-.1h-2.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M13.1 26.8h-1.5l-.3-.1H11l-.4.1v.2h1.6l.3-.1h.3l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M13.1 26.8h-1.5l-.3-.1H11l-.4.1v.2h1.6l.3-.1h.3l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M13.1 27.2h-.3l-.3-.1h-.3l-.3.1h-.3l-.3-.1H11l-.4.1V27h1.6l.3-.1h.3l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M13.1 27.2h-.3l-.3-.1h-.3l-.3.1h-.3l-.3-.1H11l-.4.1V27h1.6l.3-.1h.3l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M13.1 27.4h-.3l-.3-.1h-.3l-.3.1h-.3l-.3-.1H11l-.4.1v-.2h.4l.3-.1h1.5l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M13.1 27.4h-.3l-.3-.1h-.3l-.3.1h-.3l-.3-.1H11l-.4.1v-.2h.4l.3-.1h1.5l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m11.2 25.7-.2.2h1.8l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m11.2 25.7-.2.2h1.8l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.2 25.5h1.4v.1h-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11.2 25.5h1.4v.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11 26.4h1.8v-.5H11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11 26.4h1.8v-.5H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M10.8 23.9q-.3 0-.3.3h.2q.2.3.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M10.8 23.9q-.3 0-.3.3h.2q.2.3.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M11.2 25.5h1.3V19h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M12.2 19.1v6.4m.1-6.4v6.4m-1 0h1.2V19h-1.3v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M13.9 21.5q-1-.3-2-.2-1.2.2-1.3.7l-.3-.7q0-.4 1.5-.7h2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M13.9 21.5q-1-.3-2-.2-1.2.2-1.3.7l-.3-.7q0-.4 1.5-.7h2.1v.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M11.2 22.3q-.5 0-.6-.3l.3-.4h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M11.2 22.3q-.5 0-.6-.3l.3-.4h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m12.5 21.8.5.1q0 .3-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m12.5 21.8.5.1q0 .3-.5.5v-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m10.4 23.5.8-.5.7-.2q1.1-.6 1.1-.8l.1.6q0 .3-1 .8l-.9.3-.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m10.4 23.5.8-.5.7-.2q1.1-.6 1.1-.8l.1.6q0 .3-1 .8l-.9.3-.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M11.1 21.2q.3 0 .3-.3h-.5l.2.5h.1zm0-.3v.2zm.6-.2v.6l.4-.1h-.2zm.7.5.2-.6h-.1q0 .3-.2.4l-.2-.3H12zm.7-.4v-.1h-.4l.3.4h-.2.3l-.2-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M23.8 17.6v.1H23v-.1q0-.2.2-.2h1.3l.2.1v.2h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.6v.1H23v-.1q0-.2.2-.2h1.3l.2.1v.2h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m23.7 17.3.1-.2.1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7 17.3.1-.2.1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.8 17.3v-.2zv.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.3v-.2zv.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.3 18v-.1q.5-.3 1.1 0h-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 18v-.1q.5-.3 1.1 0h-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.8 18.1h.5V18h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 18.1h.5V18h-1zm.1-.9h.1m.7.4a.2.2 0 0 0-.3-.3m-.1.1-.2-.2h-.2m.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24.4 17.8h-.1v-.1h-1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 17.8h-.1v-.1h-1v.1zm-1.5-.2v-.2l.2-.1h.1m.1.1q0-.2.2-.2h.1m-.8.1h.1m.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.8 17.6h.4l.1.1h.2v.1h-.1l-.2-.1h-.6a.1.1 0 0 1-.2 0h-.1l-.1.1-.2-.1h.4v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.6h.4l.1.1h.2v.1h-.1l-.2-.1h-.6a.1.1 0 0 1-.2 0h-.1l-.1.1-.2-.1h.4v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.8 17.8h-.6zh.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.8h-.6zh.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M23.8 17.9h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.9h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M23.4 18h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 18h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M24.2 18v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 18v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M23.8 18h-.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 18h-.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.8 17.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.7 17.5h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7 17.5h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24 17.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.4 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 17.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.6 17.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 17.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24.3 17.4v.2l-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 17.4v.2l-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24.4 17.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 17.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24 17.5h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24.5 17.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.7 17.1h.2zm.2-.1v.1h-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 17v.1h-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24 17v.1h-.3.1v-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 17v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m23 17.7-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 17.7-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m24.6 17.7.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 17.7.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23 18.6h1.7V18H23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23 18.6h1.7V18H23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M24.5 18.9H23l.1-.1v-.1h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M24.5 18.9H23l.1-.1v-.1h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.2 18.9h1.3v.1H23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.2 18.9h1.3v.1H23v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.2 18.6h1.3zH23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.2 18.6h1.3H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "m22.6 26.5.3-.1H25v.3l-.4-.1h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.6 26.5.3-.1H25v.3l-.4-.1h-2.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m22.6 26.7.3-.1H25v.2h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.6 26.7.3-.1H25v.2h-2.5v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M22.6 26.8H24l.3-.1h.4l.3.1v.2h-.4l-.3-.1H24l-.3.1h-.3l-.3-.1h-.3l-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.6 26.8H24l.3-.1h.4l.3.1v.2h-.4l-.3-.1H24l-.3.1h-.3l-.3-.1h-.3l-.3.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M22.6 27.2h.3l.3-.1h.3l.3.1h.3l.3-.1h.4l.3.1V27h-.4l-.3-.1h-.3l-.3.1h-.3l-.3-.1h-.3l-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.6 27.2h.3l.3-.1h.3l.3.1h.3l.3-.1h.4l.3.1V27h-.4l-.3-.1h-.3l-.3.1h-.3l-.3-.1h-.3l-.3.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M22.6 27.4h.3l.3-.1h.3l.3.1h.3l.3-.1h.4l.3.1v-.2h-.4l-.3-.1h-.3l-.3.1h-.3l-.3-.1h-.3l-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.6 27.4h.3l.3-.1h.3l.3.1h.3l.3-.1h.4l.3.1v-.2h-.4l-.3-.1h-.3l-.3.1h-.3l-.3-.1h-.3l-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m24.5 25.7.2.2H23q.2 0 .2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m24.5 25.7.2.2H23q.2 0 .2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23.2 25.5h1.3v.1H23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.2 25.5h1.3v.1H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M23 26.4h1.7v-.5H23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23 26.4h1.7v-.5H23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M24.9 23.9q.3 0 .3.3H25q-.2.3-.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.9 23.9q.3 0 .3.3H25q-.2.3-.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M23.2 25.5h1.3V19h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.1 19v6.5m.2-6.4v6.3m-1.1 0h1.3v-6.3h-1.3v6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M21.9 21.5q.9-.3 1.9-.2 1.3.2 1.3.7l.3-.7q0-.4-1.5-.7h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.9 21.5q.9-.3 1.9-.2 1.3.2 1.3.7l.3-.7q0-.4-1.5-.7h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M24.5 22.3q.5 0 .6-.3l-.3-.4h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.5 22.3q.5 0 .6-.3l-.3-.4h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m23.2 21.8-.5.1q0 .3.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23.2 21.8-.5.1q0 .3.5.5v-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m25.3 23.5-.8-.5-.7-.2q-1.1-.6-1.1-.8v.6q-.2.3 1 .8l.8.3.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m25.3 23.5-.8-.5-.7-.2q-1.1-.6-1.1-.8v.6q-.2.3 1 .8l.8.3.7.4v-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m22.7 21.2.1-.6-.2.5-.2-.4h-.2zm.5-.6H23v.6h.3-.3zm.5.1h.2-.5.2v.5zm.2.5h.2V21v.1l.1.2h.1V21l.1-.2-.2-.1H24zm.3-.4v.2zm.6.6v.2h.2v-.5l-.6.3h.1l.1-.1zm-.1-.1.2-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9 16 .2.1q0 .2-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m17.8 14.6 1.3.2q.6.3 1.2.2a2 2 0 0 1 1.5.6l-.1.1v.3l-.4.4-.2.2-.4.3h-.2v.2l-2.7-.3-2.6.3v-.2h-.3l-.4-.3-.2-.2-.3-.4v-.3l-.2-.1.6-.4.9-.2h.5q.4 0 .7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.9 18-2.6-.2v-.2l2.6-.3 2.5.3a.1.1 0 0 1 0 .2q-1.1.3-2.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M17.8 18q-1.2 0-2.2-.3 1-.2 2.2-.2t2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18v-.6m-.2.6v-.6m-.2.6v-.6m-.1.6v-.6m-.1.6v-.6m-.2.5v-.4m0 .4v-.4m-.3.4v-.4m.2.4v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.7 17.9v-.4m0 .4v-.4m.2.4v-.4m-.3.4v-.4m-.1.4v-.4m-.1.4v-.4m-.2.3v-.2m0 .3v-.3m-.1.2v-.2m-.1.2v-.2m-.1.2v-.2m-.1.2v-.2m-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18v-.5m-.3.5v-.6m-.1.6v-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m17.8 17.3-2.5.3v-.2l-.2-.2 2.7-.4q1.5 0 2.8.4l-.2.2v.2q-1-.3-2.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.8 17.3-2.5.3v-.2l-.2-.2 2.7-.4q1.5 0 2.8.4l-.2.2v.2q-1-.3-2.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.8 16.8-2.8.3V17l2.8-.4q1.7 0 2.8.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M17.8 18q-1.2 0-2.2-.3 1-.2 2.2-.2t2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17 17h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M17.8 17.1h-.2V17h.6v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 17.1h-.2V17h.6v.1h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.5 17.2h-.2V17h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.7 17.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.7 17.2h.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M15.2 17.4v-.2h.3l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.2 17.4v-.2h.3l-.2.2h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.2 17.2h.2V17h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.4 17h.1v.1m1.4.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.8 17.2h.1-.1m-1.4-.1.1-.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.5 17.4v-.2H20l.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m15.4 17.7 2.4-.2q1.5 0 2.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m15.9 15.3.2-.3-.3-.6q.1-.5 1-.6.4 0 .7.2v-.2l-.7-.1q-1 0-1.1.7l.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.9 15.3v.1l.2-.3-.3-.6q.1-.5 1-.6.4 0 .7.2v-.2l-.7-.1q-1 0-1.1.7l.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m15.9 15.3-.4-.6q0-.4.5-.7l-.3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m15.9 15.3-.4-.6q0-.4.5-.7l-.3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m14 15.6-.2-.5.1-.3q.3-.6 1.3-.6h.5v.2h-.5q-.8 0-1.2.4v.6l.2.2-.2.3h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m14 15.6-.2-.5.1-.3q.3-.6 1.3-.6h.5v.2h-.5q-.8 0-1.2.4v.6l.2.2-.2.3h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m14.2 14.4-.3.4.1.8-.1.2-.2-.5q0-.6.5-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m14.2 14.4-.3.4.1.8-.1.2-.2-.5q0-.6.5-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.8 13.7q.3 0 .3.2v.4l.2.8-.5.4-.4-.4.1-.7v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 13.7q.3 0 .3.2v.4l.2.8-.5.4-.4-.4.1-.7v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m17.8 13.8.2.1v.4l.1.7-.3.3-.2-.3v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.8 13.8.2.1v.4l.1.7-.3.3-.2-.3v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m19.8 15.3-.1.1-.2-.3.3-.5q0-.6-1-.7l-.7.2v-.2l.8-.1q1 0 1 .7l-.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.8 15.3-.1.1-.2-.3.3-.5q0-.6-1-.7l-.7.2v-.2l.8-.1q1 0 1 .7l-.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m19.8 15.3.3-.6q0-.4-.4-.7a.7.7 0 0 1 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.8 15.3.3-.6q0-.4-.4-.7a.7.7 0 0 1 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M21.7 15.6v-.8q-.1-.6-1.3-.6H20l.1.2h.4q1 0 1.2.4l.1.3zl.2.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.7 15.6v-.8q-.1-.6-1.3-.6H20l.1.2h.4q1 0 1.2.4l.1.3-.2.5.2.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m21.4 14.4.4.4-.1.8v.2q.3-.2.3-.5 0-.6-.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m21.4 14.4.4.4-.1.8v.2q.3-.2.3-.5 0-.6-.6-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.7 15.1.1-.1.2.1q0 .2-.2.2a.1.1 0 0 1-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.7 15.1.1-.1.2.1q0 .2-.2.2a.1.1 0 0 1-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.7 14.8.1-.1.2.1q0 .2-.2.2a.1.1 0 0 1-.1-.2Zm0-.3h.3l-.2.1Zm0-.2h.2zm0-.3h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 16a.4.4 0 0 0 .4.5l.4-.2V16v.1q.1.3.5.4a.4.4 0 0 0 .4-.5h.1v.3l.4.3q.2 0 .3-.2 0 .3.2.3l.4-.1.2-.3v.2l-.3.3h-.3l-.2-.1h-.6l-.2-.3a1 1 0 0 1-.9 0l-.4.2-.4-.3a.6.6 0 0 1-1 .1h-.8l-.5.4-.3-.1-.2.2-.3-.1-.4-.3v-.2l.3.3.4.1.1-.2v-.2l.1.1.3.2a.4.4 0 0 0 .4-.5V16l.1.1v.1q0 .4.4.4.3 0 .4-.4h.1l.4.3a.4.4 0 0 0 .4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.6 16.5-.1-.2-.1.1v.2zm-1.8-.4h-.1v.2zm-2 0h.2v.2zm-1.8.4v-.2l.2.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.9 16.1h.1v.2l-.1-.2m3.7.4-.1-.2-.1.1v.2zm-1.8-.4h-.1v.2zm-3.7.4v-.2l.2.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m15.9 15.3.2.3.1-.1v.4h-.4l-.1-.2v-.1h.1zm.1.8V16h-.2l-.1-.1h-.1l-.2.3h.3v.1h.2zm.2 0v-.2h.1l.2-.2v.1l.4.1-.3.2H16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m15.9 15.3.2.3.1-.1v.4h-.3m0 0h-.1l-.1-.2v-.1h.1v-.3m0 .7.1.1m0-.1h-.2l-.1-.1h-.1l-.2.3h.3v.1h.2l.1-.2m.2 0v-.2h.1l.2-.2v.1l.4.1-.3.2H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m15.9 16 .1-.1.2.1q0 .2-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.8 15 .2.4h.2l-.1.2-.1.2h-.2l-.2-.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.7 16v-.2l-.1-.1h-.3l-.3.2.3.1v.1h.3zm.3 0v-.2l.1-.1h.3l.3.2-.3.1v.1H18zm1.8-.7-.2.3-.1-.1v.4h.4v-.2l.2-.1h-.2zm0 .8V16h.1l.2-.1h.1l.2.3h-.3v.1h-.2zm-.3 0v-.2l-.2-.2v.1l-.4.1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.7 16v-.2l-.1-.1h-.3l-.3.2.3.1v.1h.3l.1-.1m.3 0v-.2l.1-.1h.3l.3.2-.3.1v.1H18V16m1.8-.7-.2.3-.1-.1v.4h.3m0 0h.1v-.2l.2-.1h-.2l-.1-.3m0 .7v.2l.3.1.3-.1-.2-.2v-.1zm-.3.1v-.2l-.2-.2v.1l-.4.1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m19.5 16 .2-.1.1.1-.1.2zm2 .4h-.3v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.4 16.4h-.2v.2h.2v-.2m-1.9-.4.2-.1.1.1-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m21.2 16.5.2-.1.2-.2h.3a.2.2 0 0 0-.2-.3l-.2.1h-.2v.4-.1L21 16h-.2l-.3.1.2.2v.1h.3m-6.6 0-.2-.1-.2-.2h-.3a.2.2 0 0 1 .2-.3l.2.1h.2v.4-.1l.3-.2.4.1-.2.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m21.2 16.5.2-.1.2-.2h.3a.2.2 0 0 0-.2-.3l-.2.1h-.2v.4-.1L21 16h-.2l-.3.1.2.2v.1h.3m-6.6 0-.2-.1-.2-.2h-.3a.2.2 0 0 1 .2-.3l.2.1h.2v.4-.1l.3-.2.4.1-.2.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M14.3 16.4q.2.1 0 .2h-.1zm3.4-.5.1-.2q.2 0 .2.2l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M14.3 16.4h.1q.2.1 0 .2h-.1v-.2m3.4-.5.1-.2q.2 0 .2.2l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M17.5 13.4q0-.3.3-.3t.4.3-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.7 12.4v.2h-.2v.2h.2v.5h-.2v.2h.7v-.1h-.3v-.6h.2v-.2H18v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M17.9 27.6q-1.5 0-3-.7a2 2 0 0 1-1-1.7v-2.7h8v2.7a2 2 0 0 1-1 1.7q-1.5.6-3 .7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 27.6q-1.5 0-3-.7a2 2 0 0 1-1-1.7v-2.7h8v2.7a2 2 0 0 1-1 1.7q-1.5.6-3 .7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M17.9 22.5h4V18h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 22.5h4V18h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M17.9 25.2c0 1-1 1.9-2 1.9a2 2 0 0 1-2-2v-2.6h4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m14.7 26.7.5.3v-4.6h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M13.8 25.1q0 .8.5 1.3v-4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7b500",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.6 27h.5v-4.6h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m16.5 27 .5-.2v-4.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M13.8 22.5h4V18h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M13.8 22.5h4V18h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.4 26.3q.3-.2.5-1v-2.9h-.5v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 25.2c0 1-1 1.9-2 1.9a2 2 0 0 1-2-2v-2.6h4v2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M21.9 22.5v2.7c0 1-1 1.9-2 1.9a2 2 0 0 1-2-2v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.9 22.5v2.7c0 1-1 1.9-2 1.9a2 2 0 0 1-2-2v-2.6h4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M18.6 24.5v.1h-.3l.1.1v.4h.2v-.4h.5v-.2zm1.8 0v.1h-.3l.3.5-.4-.4v.8h-.2v-.7l-.4.4-.1-.1.4-.4h-.4v-.2zm.2 0v.1h.4l.1.1v.4h.2v-.4l.1-.1h-.8m-.5 1.9.3-.1zl-.2.1-.2-.1-.4-.1v-.1h.5v-.6h.1v.5zm-1-.2-.3-.2h-.2v-.3l-.2-.4h.2v.3h.2l.3-.3h.1l-.3.4v.3zm-.5-.4h.2a.1.1 0 0 1-.2 0m-.1-.4h-.2V25h.1v.4m0-.4h.2v.3l-.1-.1zm.6 1q0 .3.3.3v-.1zm-.1.2.4.2-.1.1-.4-.1zm.2-.8h.1l.3-.2-.1-.1zm-.1 0-.1-.2.2-.2h.2zm1.5.8.3-.2h.2l.1-.2v-.5l-.2.3-.4-.3h-.1l.3.4v.3zm.5-.4a.1.1 0 0 0-.2 0 .1.1 0 0 0 .2 0m.1-.4h.2V25h-.1zm0-.4H21v.3h.1zm-.5 1-.4.3v-.1zm0 .2-.4.2.1.1.4-.1zm-.1-.8h-.2l-.2-.2v-.1zm0 0 .1-.2-.2-.2h-.1zm-1.6-.8h.4zm1.7 0h-.4zm-1 1.8h.2v.1zm.2-.6h.2v-.4h-.2zm-.1 0h-.1v-.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m18.3 24.5.1-.1v-.5h.2v.5h.5v.1zm1 0h.3l-.4-.5h.1l.5.4v-.6h.1v.6l.4-.5h.1l-.4.5h.4v.1zm1.8 0h.3l-.1-.1v-.5H21v.5h-.5v.1zm-2.5-1.2.5.5h.1l-.5-.6h.4V23h-.4l-.2-.1-.2.2.1.2v.4h.2zm2.7 0v.4H21v-.4l-.5.5h-.1l.5-.6h-.4V23h.4l.2-.1.2.2zm-1.4 0v.2h-.1zl-.2-.2h-.3V23h.3l.2-.1.2.1h.4v.1H20zm-1.5.3v.4h.1zm.2 0h.1v.4h-.1zm2.5 0H21v.4h.1zm.1 0h.2v.4h-.2zm-2 0 .3.3v.1zm-.2.1v.2l.2.2h.1zm1.6 0-.2-.1-.2.3zm0 0 .1.2-.2.2h-.1zm-1.6.8h.4zm-.6-1.4.1-.1v.2zm1 0v.2H19V23zm0 0v-.2H19v.1zm1.3 1.4h-.4zm.4-1.4V23h.2zm-1.4 0 .1-.1h.1v.2zm.6 0v.2h.4V23zm0 0v-.2h.4v.1zm-.5.3h-.2v.4h.2zm.1 0h.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 26.4.4-.1zl-.2.1-.2-.1-.4-.1v-.1h.4v-.6h.2v.5zm-.3-1.7h-.4v-.2h.3l-.4-.5h.2l.4.4v-.6h.1v.6l.5-.5-.4.5h.4v.2h-.3l.3.5-.5-.4v.8h-.1zl-.4.4-.1-.1zm-1.1-1.4.5.5h.1l-.5-.6h.4V23h-.4l-.2-.1-.2.2.1.2v.4h.2zm.5 2.9q-.2 0-.3-.2h-.2v-.3l-.2-.4h.2v.3h.2l.3-.3h.1l-.3.4v.3zm-.7-1.1v-.4l-.1-.1.1-.2v-.5h.2v.5h.5v.2h-.4l-.1.1v.4zm.2.7h.2a.1.1 0 0 1-.2 0m-.1-.4h-.2V25h.1v.4m0-.4h.2v.3h-.1zm.5 1 .4.3v-.1zm0 .2.4.2-.1.1-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 23.6v.4h.1zm.2 0v.4h-.1zm.6 1.8.3-.2v-.1zm-.1 0-.1-.2.2-.2h.2zm-.7-.8.1-.1h.1v.1zm2.2 1.6.3-.2h.2v-.3l.2-.4H21v.3h-.2l-.3-.3h-.1l.3.4v.3zm.7-1.1v-.4l.1-.1-.1-.2v-.5H21v.5h-.5v.2h.4l.1.1v.4zm-.2.7a.1.1 0 0 0-.2 0 .1.1 0 0 0 .2 0m.1-.4h.2V25h-.1zm0-.4H21v.3h.1zm0-1.7v.4zH21l-.5.5h-.1l.5-.6h-.4V23h.4l.2-.1.2.2zm-1.3 0v.2h-.1v-.2l-.2-.2h-.3V23h.3l.3-.1.2.1h.3v.1H20zm.8 2.8-.4.2v-.1zm0 .1-.4.2.1.1.4-.1zm.4-2.6v.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 23.6v.4h-.1zm-1-.5v.2h.4V23zm-.5.3h-.2v.4h.2zm.7 2-.3-.2v-.1zm.1 0 .1-.2-.2-.3-.1.1zm-1.5-1.7h.2l.2.2v.1zm0 0-.2.2.3.2h.1zm1.5 0-.2-.1-.2.3zm0 0 .1.2-.2.2h-.1zm-1.6.8h.4zm0 .1v.1h.4zm-.6-1.5.1-.1h.1v.2zm1 0v.2H19V23zm0 0v-.2H19v.1zm1.7 1.5h.2zm-.4-.1h-.4v.1zm0 .1v.2h-.4v-.2zm-1 1.8h.2v.1h-.1m.2-.6h.2v-.4H20zm-.1 0h-.2v-.4h.2zm1.3-2.7V23h.2zm-1.3 0V23h.1zm.5 0V23h.4v.1zm-.4.3h.2v.4H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M19.6 24.6a.2.2 0 0 1 .5 0l-.2.2q-.3 0-.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M20 19.1h-.3l-.2-.1-.1-.1h-.2l.2.1.1.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20 19.1h-.3l-.2-.1-.1-.1h-.2l.2.1.1.1h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed72aa",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.5 19v.4-.1.5h-.1l-.1-.2v.4l-.1-.1.2.4q0 .2.4.3.4-.2.1-.6v-1l.1-.1v-.1.2l.2-.1.1-.1v.1l-.1.2h.1v.1l-.2.2-.1.1v.4l.1.5v.3l-.4.1v.5h.1v.7h-.4v-.1q0-.2 0 0v-.2h.2v-.2h-.1v-.1.1h-.1v-.1.1h-.1l-.1-.1V21h-.3v.4h-.4v.1h-.1v-.1h-.2v-.2h.1V21h.1l.2.1h.1V21v.1-.2h-.1v.1-.2l.1-.2h.4l-.3-.2-.2-.1V20l-.2.1v.1-.1l-.1.1h-.4v.2h-.1v-.1h-.1V20h.3l.1-.1h.2l-.1-.1-.1-.1h-.2v-.2h-.2.2l-.1-.1v-.1h-.2v-.5l.1.1v-.1h.2v.4h.2l.2.1h.4v-.2h.2V19l-.2-.1v-.1h.2v-.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20 18.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.8h.2zm.4.5v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M18.8 18.9h.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.8 18.9h.1v-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M18.6 19h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.6 19h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "m18.5 19.2-.1.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18.5 19.2-.1.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.7 19.2h.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 19.5h-.1v.1h.2v.3h.2v-.2.2h.2v-.1l.1.1v.1h.1v-.2m-.8.1.1-.1h.1m.1.3h.1V20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M18.7 20h-.2zv.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.7 20h-.2.1v.1zm-.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M18.8 20.5v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.1 20.6.2.2-.1.2m-1.4-.5v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M19.3 21H19zv.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.3 21H19h.1v.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M19.2 21.3H19v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.2 21.3H19v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M19.3 21.5v.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.3 21.5v.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "m20.3 21.6-.1.1h.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.3 21.6-.1.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M20.4 21.9v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.4 21.9v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M20.6 22h.1v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.6 22h.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd691",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18 26.4q.3 0 .3.3t-.4.3-.4-.3.2-.3v-.1h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "m17.9 27.2-.5-.2h-.5.2l.3.2zm0 0 .5-.2h.5l-.1.1-.4.1H18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.9 27.2-.5-.2h-.5.2l.3.2h.5m0 0 .5-.2h.5l-.1.1-.4.1H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 27a.4.4 0 0 1 0-.6l.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 27.4V27h.1v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.8 15.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.8 15.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 15.7h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22 15.7v-.1h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 15.4h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22 15.4h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22 15.2.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22 15.2.1-.1h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 15v-.2l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22 15v-.2l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 14.7.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m21.8 14.7.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.7 14.5h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.7 14.5v-.1h.1v.2zm-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.2 14.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.2 14.2h.2zM21 14Zm-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.4 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.4 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.1 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.1 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.8 14h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.8 14h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 14.3h.1zm0 .2h.2zm0 .3.1-.1h.1zm0 .3h.1zm-.2.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20 14.3v-.1h.1v.1H20m0 .5.1-.1h.1-.2m0 .3h.1-.1m-.2.2h.2l-.1.1m.1-.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.6 13.9.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.6 13.9.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.4 13.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 13.8v-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.1 13.7.1-.1h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.1 13.7.1-.1h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.9 13.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.9 13.6h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.6 13.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.6 13.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.3 13.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.3 13.7v-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18 13.8.1-.1h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18 13.8.1-.1h.1v.1zm-4.3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 15.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m13.5 15.7.1-.1h.1v.2zm0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 15.2V15h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M13.5 15.2V15h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 15 .1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m13.5 15 .1-.2zm.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.8 14.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m13.8 14.5.1-.1h.1v.2zm.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.3 14.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M14.3 14.2h.2zm.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.8 14h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M14.8 14h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.1 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.1 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.4 14h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.4 14h.2zm.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.4 15.2h.2zm.2.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m15.5 14.3.1-.1m-.2.6.1-.1h.1-.1m0-.2zm0 .5h.2zm.2.2h.2l-.1.1zm.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.1 13.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.1 13.8v-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.4 13.7h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.4 13.7v-.1h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.6 13.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.6 13.6h.2zm.4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 13.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.2 13.7v-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 13.8.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.4 13.8.1-.1h.1l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M15.2 19H15v.3h.2v.2h-.3v.6h.1v1.2h-.3v.6H17v-.6h-.3V20h.2v-.6h-.3v-.2h.1V19h-.6v.3h.2v.2H16v-.6h.1v-.3h-.5v.3h.1v.6h-.2V19zm-.5 2.9H17Zm0-.2H17Zm0-.1H17Zm0-.2H17Zm0-.1H17Zm.3-.2h1.7Zm0-.1h1.7Zm0-.2h1.7Zm0-.1h1.7Zm0-.2h1.7Zm0-.1h1.7Zm0-.2h1.7Zm-.1-.1h2Zm0-.2h2Zm0-.1h2Zm0-.2h2Zm.3-.1h1.4Zm.5-.1h.3Zm0-.2h.3Zm0-.1h.3Zm0-.2h.3Zm-.1-.2h.5Zm-.5.7h.3Zm0-.2h.5Zm0 2.7v-.2Zm0-.3v-.2Zm.1.1v-.1Zm0 .2v-.2Zm0-.3v-.2Zm0-.3V21Zm0-.3v-.2Zm0 .4v-.1Zm-.3 0v-.1Zm.7-.1V21Zm0-.3v-.2Zm0-.8v.2Zm-.6-.3v.2Zm.3 0v.2Zm.3 0v.2Zm-.6-.3v.2Zm.6 0v.2Zm1-.2h-.3Zm.1-.2h-.6Zm0 2.7v-.2Zm0-.3v-.2Zm-.1.1v-.1Zm-.2.2v-.2Zm0-.3v-.2Zm0-.3V21Zm0-.3v-.2Zm.2.4v-.1Zm.3 0v-.1Zm-.8-.1V21Zm0-.3v-.2Zm0-.8v.2Zm.6-.3v.2Zm-.3 0v.2Zm-.2 0v.2Zm.5-.3v.2Zm-.6 0v.2ZM16 21v-.2Zm0-.6v-.2Zm0 .3v-.2Zm0-.6v-.2Zm0-.3v-.2Zm0-.4v-.2Zm0-.3v-.2Zm-.7.2h.3Zm.5-.4h.3Zm.6.4h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.2 19.5v-.2H15V19h.6v.3h-.2m-.2.2h-.3v.6h.1v1.2h-.3m.5-1.8h1.4m-1.9 1.8v.6m0-.6H17m-2.3.6H17v-.6h-.3V20h.2v-.6h-.3m-1.9 2.4H17m-.4-2.4v-.2h.1V19h-.6v.3h.2v.2H16v-.6h.1v-.3h-.5v.3h.1m0 0v.6h-.2v-.2m.2-.4h.3m-.6.4h-.2m-.5 2.4H17m-2.3-.1H17m-2.3-.2H17m-2-.3h1.7M15 21h1.7m-1.7-.2h1.7m-1.7-.1h1.7m-1.7-.2h1.7m-1.7-.1h1.7m-1.7-.2h1.7m-1.8-.1h2m-2-.2h2m-2-.1h2m-2-.2h2m-1.2-.2h.3m-.3-.2h.3m-.3-.1h.3m-.3-.2h.3m-.4-.2h.5m-1 .7h.3m-.4-.2h.6m-.6 2.7v-.2m0-.1v-.2m-.1.2v.1m.3 0v-.1m0 .3v-.2m0-.1v-.2m0-.1V21m0-.1v-.2m0 .6v-.1m-.3.1v-.1m.5 0v.1m.2-.1V21m-.4-.1v.1m.2-.1v.1m.3-.1v.1m-.1-.1v-.2m.1-.1v.1m0-.4v.1m-.1-.3v.2m.1-.3v.1m-.2-.1v.1m-.3-.1v.1M15 20v.1m.3-.2v.2m.3-.2v.2m.1-.3v.1m-.2-.1v.1m-.3-.1v.1m-.2-.2v.1m.6-.2v.2m-.3-.4v.1m1.3-.1h-.3m.4-.2h-.6m.6 2.7v-.2m0-.1v-.2m.2.2v.1m-.3 0v-.1m-.2.3v-.2m0-.1v-.2m0-.1V21m0-.1v-.2m.2.6v-.1m.3.1v-.1m-.6 0v.1m-.2-.1V21m.5-.1v.1m-.3-.1v.1m-.3 0v.1m.1-.1v-.2m0-.1v.1m0-.4v.1m0-.3v.2m0-.3v.1m.2-.1v.1m.3-.1v.1m.1-.3v.2m-.3-.2v.2m-.2-.2v.2m-.2-.3v.1m.3-.1v.1m.3-.1v.1m.1-.3v.2m-.6-.2v.2m.3-.4v.1M16 21v-.2m0-.4v-.2m0 .5v-.2m0-.4v-.2m0-.1v-.2m0-.2v-.2m0-.1v-.2m.4.4h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.2 21.9v-.4q.1-.1-.4-.3-.4 0-.3.3v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.6 21.5h-.2l.1-.2zm.5 0h.2v-.2l-.3.1zm-.2-.2.1-.1h-.3v.1zm-.3-.4v-.4l-.2-.2q-.2 0-.2.2v.4zm.5 0v-.4l.2-.2q.3 0 .2.2v.4zm-.1-1v-.4h-.3v.4zm.3 0v-.4h.3v.4zm-.9 0v-.4h-.3v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0039f0",
    d: "M16.1 21.9v-.3q0-.2-.3-.3t-.2.3v.3zm-.6-1v-.4l-.1-.2q-.2 0-.2.2v.3zm.7 0v-.4q0-.2.2-.2l.1.2v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M16.6 22.5q0-1.4 1.3-1.5 1.2.1 1.3 1.5-.1 1.3-1.3 1.4-1.2-.1-1.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.6 22.5q0-1.4 1.3-1.5 1.2.1 1.3 1.5-.1 1.3-1.3 1.4-1.2-.1-1.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M17 22.5q0-1 .9-1t.9 1-1 1q-.7 0-.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17 22.5q0-1 .9-1t.9 1-1 1q-.7 0-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.4 21.7v.5l-.1-.1-.2.1.1.2h.2-.1v.2h.2v-.1h.1v-.2h.1a.1.1 0 0 0 0-.2h-.2v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 21.7v.5l-.1-.1-.2.1.1.2h.2-.1v.2h.2v-.1h.1v-.2h.1a.1.1 0 0 0 0-.2h-.2v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.3 22.5h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 22.5h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m18.3 21.7-.1.3v.2-.1l-.2.1v.2h.2v.2h.2v-.3h.1a.1.1 0 0 0 0-.2h-.1V22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3 21.7-.1.3v.2-.1l-.2.1v.2h.2v.2h.2v-.3h.1a.1.1 0 0 0 0-.2h-.1V22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M18.1 22.5h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 22.5h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m17.9 22.5-.1.2v.2h-.2v.1h.1v.4h.3V23h.1a.1.1 0 0 0 0-.2l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 22.5-.1.2v.2h-.2v.1h.1v.4h.3V23h.1a.1.1 0 0 0 0-.2l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M17.7 23.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 23.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.5 18.6h-.3v-.2H20v.2l.2.2.2.2h.2v-.1h-.1v-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.6h-.3v-.2H20v.2l.2.2.2.2h.2v-.1h-.1v-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.6 19v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 19v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.4 18.4v.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 18.4v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.4 18.6h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 18.6h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20 18.4h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.4h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.5 18.5v.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.5v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.5 18.7h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.7h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.7 19v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 19v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.7 18.8v.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 18.8v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M20.8 19v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17v.1h-.3.1v-.2.2zm-.6 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.2f99cd0ada54e08f61f7c9ec02bb1ab3.svg";
export { ForwardRef as ReactComponent };